import { render } from "./EventList.vue?vue&type=template&id=94ae9d0a&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=94ae9d0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-94ae9d0a"

export default script